// extracted by mini-css-extract-plugin
module.exports = {"holder":"BlogListContentStyle-module--holder--39Z6Y"};